var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};
OCS.WxBriefing.Classes.MyProductsMenu = new Class({
    Extends: OCS.WxBriefing.Classes.MenuObj,
    underlay: null,
    options: {
        max_weather_briefings: 24,
        menu_class_name: "my_products",
        my_products_menu_id: "my_products_menu",
        element_class_name: "my_products_menu_container",
        fetch_myproducts_location: "/index.php/api/weather_briefing/myproducts/format/json",
        fetch_myproducts_menu_location: "/index.php/api/weather_briefing/myproducts_menu/format/json",
        fetch_mypanelconfigs_location: "/index.php/api/weather_briefing/panelconfigs/format/json",
        myproduct_api_location: "/index.php/api/weather_briefing/myproduct/method/{method}/entry_id/{entry_id}/format/json",
        save_panel_config_location: '/index.php/api/weather_briefing/save_panel_config/format/json'
    },
    element: null,
    initialize: function (element, ops) {
        this.draw();
        var self = this.element.retrieve('menu_obj');
        if (self) {
            return self;
        }
        this.parent(this.element, ops);
        this.append();
        this.bound_methods.on_click = this.on_click.bind(this);
        this.bound_methods.handle_my_prod_delete = this.handle_my_prod_delete.bind(this);
        this.bound_methods.build_myproducts = this.build_myproducts.bind(this);

        var am = OCS.Functions.get_ajax_manager();
        am.request("fetch_myproducts", {
            url: this.options.fetch_myproducts_location,
            dataType: "json",
            method: "GET",
            noCache: true,
            storeCompletedReq: 0,
            onSuccess: this.handle_my_prod_init.bind(this)
        });
        am.request("fetch_mypanelconfigs", {
            url: this.options.fetch_mypanelconfigs_location,
            dataType: "json",
            method: "GET",
            noCache: true,
            storeCompletedReq: 0,
            onSuccess: this.handle_my_panelconfigs_init.bind(this)
        });
        am.request("myproduct_api", {
            url: this.options.myproduct_api_location,
            dataType: "json",
            method: "POST",
            storeCompletedReq: 0,
            onSuccess: function (resp) {
                var data = resp.json;
                $$('.loader16').removeClass('spinner');
                if (data.success) {
                    am.request("fetch_myproducts").send();
                } else {
                    alert(data.msg);
                }
            }.bind(this)
        });
        this.underlay = new OCS.WxBriefing.Classes.MenuUnderlay();
        this.element.store('menu_obj', this);
    },

    activate: function () {
        if (!OCS.device.mobile) {
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu({keep_myproducts: true});
        }
        if(!this.ul_element) {
            this.build_myproducts();
        }
        this.parent();
        if (OCS.device.mobile) {
            this.ul_element.setStyles({'height': '100%', 'display': 'none'});
            this.ul_trans.set({display: 'block'}).start({'height': [0, 100]});
        } else {
            var drop_window = new OCS.WxBriefing.Classes.DropdownWindow();
            drop_window.position(this.element).content(this.ul_element.clone()).show();
            drop_window.addEvent('click', this.bound_methods.on_click);
            
        }
        this.underlay.show();
        return this;
    },
    add_to_my_products: function (entry_id) {
        this.myproduct_api({
            method: 'save',
            entry_id: entry_id
        });
        return this;
    },
    append: function () {
        if (this.element && this.options.container) {
            this.element.inject(this.options.container);
        }
        return this;
    },
    build_myproducts: function () {
        var panel_configs = {};
        var products = [];
        if (OCS.User) {
            panel_configs = OCS.User.get_panel_configs();
            products = OCS.User.get_myproducts();
        }


        var data = {
            products: [],
            panel_configs: panel_configs
        };
        if (this.element && this.element.getParent()) {

            if (this.ul_element) {
                this.ul_element.destroy();
            }
            if (data.panel_configs && data.panel_configs.length) {
                data.panel_configs.each(function (config) {
                    config.default_configuration = config.default_configuration * 1;
                    config.panelconfig_id = config.panelconfig_id * 1;
                    config.sort_order = config.sort_order * 1;
                    config.hashstring = OCS.Settings.base_url + config.hashstring;
                });
            }

            var requests = [];
            Object.each(products, function (product) {
                var pm = OCS.WxBriefing.Functions.get_product_manager();
                if (pm.is_product_fetched(product.entry_id)) {
                    data.products.push(pm.fetch_product(product.entry_id).options);
                } else {
                    requests.push(new OCS.WxBriefing.Classes.ProductRequest({entry_id: product.entry_id}));
                }
            });
            if (requests.length) {
                var group = new Group(requests);
                group.addEvent('complete', this.bound_methods.build_myproducts);
                requests.each(function (req) {
                    req.start();
                });
            }
            var html = OCS.WxBriefing.Functions.get_template_manager().get_html('myproducts_menu', data);
            Elements.from(html).inject(this.element);
            this.ul_element = this.element.getElement('ul');
            this.ul_trans = new Fx.Morph(this.ul_element, {
                duration: 1200,
                transition: Fx.Transitions.Sine.easeInOut,
                link: 'chain',
                unit: '%'
            });
            if (this.element.hasClass('active')) {
                if (OCS.device.mobile) {
                    this.ul_element.setStyle('height', '100%');
                } else {
                    var drop_window = new OCS.WxBriefing.Classes.DropdownWindow();
                    drop_window.content(this.element.getElement('ul.myproducts').clone());
                }

            }
            this.fireEvent('myproducts_ready', this);
        } else {
            console.warn("Something went wrong with the element!", this);
        }
        return this;
    },
    deactivate: function () {
        this.parent();
        if (OCS.device.mobile) {
            this.ul_trans.start({'height': 0}).set({'display': 'none'});
        } else {
            var drop_window = new OCS.WxBriefing.Classes.DropdownWindow();
            drop_window.removeEvent('click', this.bound_methods.on_click);
            drop_window.element.getElements('.myproduct-delete').removeEvent('click', this.bound_methods.handle_my_prod_delete);
            drop_window.hide();
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
        }
        this.underlay.hide();

        return this;
    },
    draw: function () {
        if (!this.element) {
            var element = document.id(this.options.my_products_menu_id);
            if (element) {
                this.element = element;
            } else {
                this.element = new Element('li', {id: this.options.my_products_menu_id});
                new Element('div', {html: 'My Products'}).inject(this.element);
            }
        }
        return this;
    },

    /*
     * 
     * My product Api Call
     * 
     */
    myproduct_api: function (call) {
        if (call && call.method !== undefined && call.entry_id !== undefined) {
            OCS.Functions.get_ajax_manager().request("myproduct_api").set_url_keys(call).send();
        }
    },

    /*
     * 
     * Event Hanlders
     * 
     */
    on_click: function (event, target) {
        if (target.hasClass('panelconfig-delete')) { // delete briefing from list
            this.handle_delete_briefing(target.getParent());
            event.stopped = true;
        } else if (target.hasClass('myproduct-delete')) {
            this.handle_my_prod_delete(event);
            event.stopped = true;
        } else if (target.hasClass('myproductsDefault')) { // star has been clicked to make briefing a default
            this.handle_make_briefing_default(target.getParent());
            event.stopped = true;
        } else if (target.hasClass('addBriefing')) { // the "+" in My Products drop down was clicked. Add new briefing to the list.
            this.handle_add_briefing(event);
            event.stopped = true;
        }
        if(event.stopped) {
            event.stop();
        }
    },
    handle_add_briefing: function () {
        var briefingUL = this.element.getElement('ul.myBriefings');
        var liCount = briefingUL.getChildren().length;
        if (liCount > this.options.max_weather_briefings) { // limit number of briefings
            alert("You have reached the maximum number of weather briefings allowed");
        } else { // under limit
            var drop_window = new OCS.WxBriefing.Classes.DropdownWindow();
            var input = drop_window.element.getElement('input.config_name_val');
            var name = input.get('value');
            if (name.length) { //if name is given and there are products in the URL hash
                var pass = true;
                // limit size if needed
                switch (true) {
                    case (name.length < 1):
                        alert('Briefing name must be at least 1 character');
                        pass = false;
                        // removed this case for now per James request
                        //case (name.length >= 16 && name.length <= 32):
                        //    name = name.split(' ').join('');
                        break;
                    case (name.length > 32):
                        alert('Briefing name must be no more than 32 characters');
                        pass = false;
                        break;
                }
                if (pass) { // size passes requirements
                    // clean up name for security
                    name = name.replace(/([^a-z0-9' &+]+)/gi, '');
                    var nameCharCheck = name.match(/\S+/g);
                    if (!nameCharCheck || nameCharCheck.length === 0) { // NO characters entered. Only spaces, or nothing entered.
                        alert('Briefing name must be at least 1 alpha-numeric character');
                    } else {
                        var hash = window.location.hash;
                        OCS.Functions.get_ajax_manager().request("panelconfig_api-save-" + name + "-" + hash, {
                            url: this.options.save_panel_config_location,
                            dataType: "json",
                            corsRequest: false,
                            type: "POST",
                            storeCompletedReq: 1,
                            onSuccess: function (response) {
                                if (response.json && response.json.success) {
                                    OCS.Functions.get_ajax_manager().request("fetch_mypanelconfigs").send();
                                } else if (response.json && response.json.msg) {
                                    alert(response.json.msg);
                                }
                            }
                        }).send({
                            data: {
                                config_name: name,
                                hashstring: hash,
                                default_config: 0
                            }
                        });
                    }
                }
            }
        }
    },
    handle_delete_briefing: function (target) {
        var panelconfig_id = target.get('data-panelconfig_id');
        target.destroy();
        var url = OCS.WxBriefing.Functions.get_ui().options.panelconfig_api_location;
        Object.each({
            method: 'delete',
            panelconfig_id: panelconfig_id
        }, function (value, key) {
            url = url.replace('{' + key + '}', value);
        });
        OCS.Functions.get_ajax_manager().request("panelconfig_api-delete-" + panelconfig_id, {
            url: url,
            dataType: "json",
            corsRequest: false,
            type: "POST",
            storeCompletedReq: 1,
            onSuccess: function () {
                OCS.Functions.get_ajax_manager().request("fetch_mypanelconfigs").send();
            }
        }).send();
    },
    handle_make_briefing_default: function (target) {
        var default_configuration = target.get('data-default_configuration');
        if (default_configuration) {
            default_configuration = 1;
        } else {
            default_configuration = 0;
        }
        var panelconfig_id = target.get('data-panelconfig_id');

        var am = OCS.Functions.get_ajax_manager();
        var url = OCS.WxBriefing.Functions.get_ui().options.update_panel_config_location;
        var req;
        if (default_configuration) {
            // Remove it from being the default
            req = am.request("update_panel_config-" + panelconfig_id + '-default', {
                url: url,
                dataType: "json",
                corsRequest: false,
                type: "POST",
                storeCompletedReq: 1
            }).addEvent('success', function (response) {
                var data = response.json;
                if (data.success) {
                    am.request("fetch_mypanelconfigs").send();
                } else {
                    alert(data.msg);
                }
            });
            default_configuration = 0;
        } else { // make item new default
            req = am.request("update_panel_config-" + panelconfig_id, {
                url: url,
                dataType: "json",
                corsRequest: false,
                type: "POST",
                storeCompletedReq: 1
            }).addEvent('success', function (response) {
                var data = response.json;
                if (data.success) {
                    am.request("fetch_mypanelconfigs").send();
                } else {
                    alert(data.msg);
                }
            });
            default_configuration = 1;
        }
        req.send({data: {
                panelconfig_id: panelconfig_id,
                default_configuration: default_configuration
            }});
    },
    handle_my_panelconfigs_init: function (resp) {
        var data = resp.json;
        if (data.success) {
            OCS.User.set_panel_configs(data.data);
            this.build_myproducts();
        } else if (resp.msg) {
            alert(resp.msg);
        }
    },
    handle_my_prod_delete: function (event) {
        var target = event.target.getParent();
        var entry_id = target.get('data-entry_id');
        target.destroy();
        this.myproduct_api({
            method: 'delete',
            entry_id: entry_id
        });
    },
    handle_my_prod_init: function (resp) {
        var data = resp.json;
        if (data.success) {
            OCS.User.set_myproducts(data.data);
            this.build_myproducts();
        } else if (resp.msg) {
            alert(resp.msg);
        }
    },
    /*
     * 
     * Get / Set Methods
     * 
     */

    // Get default config
    get_my_default_config: function () {
        var default_el = this.element.getElement('[data-default_configuration="1"]');
        if (default_el) {
            return default_el.getProperty('data-href');
        }
        return false;


    },
    destroy: function () {
        var am = OCS.Functions.get_ajax_manager();
        am.remove_request('fetch_myproducts');
        am.remove_request('fetch_mypanelconfigs');
        am.remove_request('myproduct_api');
        this.underlay = null;
        this.parent();
    }
});